import { TourState } from 'types/tour';

import { HOME } from './path';

export const tourInitialState: TourState = {
  run: false,
  stepIndex: 0,
  nextStepIndex: null,
  currentPage: HOME,
  steps: [],
  isLoading: false,
  tourActive: false,
  jobId: null,
  applicationId: null,
  isOpenApplicationTour: false,
  isOpenJobTour: false,
  isFullGuide: false
};

export const TOUR_STEP_TARGET_VIEW_ALL_JOBS_BUTTON =
  'tour-view-all-jobs-button';
export const TOUR_STEP_TARGET_FIRST_JOB_CARD_ACTION_MENU =
  'tour-first-job-card-action-menu';
export const TOUR_STEP_TARGET_GENERATE_WITH_AI_BUTTON =
  'tour-generate-with-ai-button';
export const TOUR_STEP_TARGET_JOB_MATCHES_TAB = 'tour-job-matches-tab';
export const TOUR_STEP_TARGET_FIRST_APPLICATION_CARD_ACTION_MENU =
  'tour-first-application-card-action-menu';
export const TOUR_STEP_TARGET_APPLICATION_INTERVIEW_TAB =
  'tour-application-interview-tab';
export const TOUR_STEP_TARGET_APPLICATION_OFFER_TAB =
  'tour-application-offer-tab';

export const APPLICATIONS_MANAGEMENT_TOUR_DELAY_MS = 200;
export const HOW_IT_WORKS_TOUR_DELAY_MS = 500;
export const TOUR_ELEMENT_POSITION_STABLE_DURATION_MS = 300;
export const TOUR_SCROLL_TO_ELEMENT_OFFSET = 100;
export const TOUR_CLOSE_SIDEBAR_DELAY_MS = 200;
export const TOUR_SCROLL_TO_TOP_DELAY_MS = 200;
export const TOUR_START_FULL_TOUR_DELAY_MS = 500;
export const TOUR_ELEMENT_POSITION_STABLE_TIMEOUT_MS = 10000;
export const TOUR_WAIT_FOR_TARGET_MOUNT_TIMEOUT_MS = 1000;
